import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import NavItem from './NavItem';
import NavList from './NavList';
import LassraLogo from 'src/components/LassraLogo';

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const USERTYPE = {
  1: 'admin',
  0: 'issuer'
};

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const profile = useSelector((state) => state.Auth.profile);
  const [priviledgedModules, setPriviledgedModules] = useState([]);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const resolvePriviledge = () => {
    const priviledges = JSON.parse(profile.priviledges || '[]');

    const dashboard = NavList.filter(
      (item) => item.id === 'dashboard' || item.id === 'profile'
    );

    const modules = [];
    priviledges.forEach((item) => {
      const moduleType = item.split('_')[0].toLowerCase();
      if (moduleType === USERTYPE[profile?.super]) {
        modules.push(item.split('_').slice(1).join('_').toLowerCase());
      }
    });

    const allowedModules = NavList.filter((item) => modules.includes(item.id));
    setPriviledgedModules([dashboard[0], ...allowedModules, dashboard[1]]);
  };

  useEffect(() => {
    if (profile) {
      resolvePriviledge();
    }
  }, [profile]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="column" p={2}>
        {/* <LassraLogo /> */}
        <Typography className={classes.name} color="textPrimary" variant="h5">
          LASRRA API Manager
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {/* {user.jobTitle} */}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {/* {NavList.filter((item) => profile?.super != item.super).map(
            (item) => (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
              />
            )
          )} */}
          {priviledgedModules.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
